import React, { useEffect, useState } from 'react';
import ContactForm from '../ContactFrom/ContactForm'
import { Link } from 'react-router-dom'
import { axiosClient } from '../../config/axios.config';
import { fetchItem } from '../../utils/fetchItem';

const Contactpage = () => {
    const [generalDetails, setGeneralDetails] = useState({});
    const [address, setAddress] = useState({});
    fetchItem('/user/general/location', setAddress);
    useEffect(() => {
        (async () => {
         await axiosClient.get('/user/general/details').then((response) => {
            setGeneralDetails(response.data.data[0])
         })
        })()
    },[])

    return (
        <section className="contact-pagg-section">
         
            <div className="contact-page separator-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <div className="contact-area-wrapper">
                                <div className="contact-form-area">
                                    <h2>Drop A Line!</h2>
                                    <ContactForm />
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-5">
                            <div className="office-info">
                                <div className="heading-title">
                                    <small>Contact us</small>
                                    <h2><span>get in touch!</span></h2>
                                    <p>{address.address}</p>
                                    <div className="contact-info">
                                        <ul>
                                            <li><i className="icon-31"></i> Manager : {generalDetails.manager_number} </li>
                                            <li><i className="icon-31"></i> Workshop: {generalDetails.workshop_number} </li>
                                            <li><i className="icon-31"></i> Sales : {generalDetails.sales_number} </li>
                                            <li><i className="icon-31"></i> Land line : {generalDetails.landline} </li>
                                            <li><i className="icon-30"></i> Email : {generalDetails.email_one}</li>
                                            <li><i className="icon-30"></i> Email : {generalDetails.email_two}</li>

                                        </ul>
                                    </div>
                                    <div className="info-social">
                                        <ul>
                                            <li><Link to="/contact" ><i className="icon-35"></i></Link></li>
                                            <li><Link to="/contact" ><i className="icon-32"></i></Link></li>
                                            <li><Link to="/contact" ><i className="icon-34"></i></Link></li>
                                            <li><Link to="/contact" ><i className="icon-33"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="map-section ">
                <h2 className="hidden">Contact map</h2>
                <div className="map">
                    <iframe title='map'
                        src={address.location_map_url}
                        allowfullscreen></iframe>
                </div>
            </div>


        </section>
    )

}

export default Contactpage;
